import { CashoutErrorType } from '@bpos/v1/cashout';

import { BetPlacementErrorIcon } from '../bet-placement-error-icon';
import { BetslipError } from '../betslip-error';

export class PayoutError extends BetslipError {
    override type: CashoutErrorType;

    constructor() {
        super();
        this.type = CashoutErrorType.TechnicalError;
        this.icon = BetPlacementErrorIcon.Error;
    }
}
